export default "__VITE_ASSET__uxOmiVli__"